exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ItemQuestion{padding:20px;overflow:hidden;overflow-y:auto;height:100%;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Slider/components/Slide/components/ItemQuestion/style.scss
// module id = 5290
// module chunks = 0